import { render } from "./products-image-page.vue?vue&type=template&id=27b44f5f"
import script from "./products-image-page.vue?vue&type=script&lang=js"
export * from "./products-image-page.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__